import msTeamsSrc from '../../assets/c2c-integrations/ms_teams_vendor_connect.svg';
import qscReflectSrc from '../../assets/c2c-integrations/qsc_reflect_vendor_connect.png';
import xioCloudSrc from '../../assets/c2c-integrations/xio_cloud_vendor_connect.svg';
import zoomSrc from '../../assets/c2c-integrations/zoom_vendor_connect.svg';

export type C2CIntegrationId = 'zoom' | 'mtr' | 'xio' | 'q_sys';

export interface C2CIntegrationItem {
  id: C2CIntegrationId;
  logo: string;
  name: string;
  description: string;
}

export const C2C_INTEGRATIONS = {
  mtr: {
    id: 'mtr',
    name: 'Microsoft Teams Rooms',
    logo: msTeamsSrc,
    description:
      'Microsoft Teams Rooms is a platform for video meetings and conference calls that can be integrated with IoT cloud providers to connect IoT devices and provide enhanced collaboration and communication capabilities. Additionally, sensor data from IoT devices can be integrated to provide real-time insights and analytics.',
  },
  zoom: {
    id: 'zoom',
    name: 'Zoom Rooms',
    logo: zoomSrc,
    description:
      'Zoom Rooms integration with a cloud IoT provider allows users to control and manage connected devices in a meeting room through the Zoom Rooms interface, and use device data to enhance the meeting experience, such as optimize audio and video quality.',
  },
  xio: {
    id: 'xio',
    name: 'Crestron XiO Cloud',
    logo: xioCloudSrc,
    description: `Crestron XiO is a cloud-based platform that integrates Crestron devices with IoT providers for remote monitoring, control, and data collection. The integration process involves connecting to the provider's cloud platform and using their API.`,
  },
  q_sys: {
    id: 'q_sys',
    name: 'QSC Reflect',
    logo: qscReflectSrc,
    description:
      'QSC Reflect is a software that allows for integration of IoT devices with cloud providers by collecting and analyzing data from the devices and triggering actions in the cloud. It can connect to multiple cloud platforms such as AWS, Azure, and Google Cloud.',
  },
} as const satisfies Record<C2CIntegrationId, C2CIntegrationItem>;
